import { EnumCountry } from './Generated';
import { SelectOption } from '@synqo/frontend-component-library';

export const countryOptions: SelectOption<EnumCountry>[] = [
    { name: 'germany', label: 'Deutschland', value: EnumCountry.Germany },
    { name: 'albania', label: 'Albanien', value: EnumCountry.Albania },
    { name: 'andorra', label: 'Andorra', value: EnumCountry.Andorra },
    { name: 'belarus', label: 'Belarus', value: EnumCountry.Belarus },
    { name: 'belgium', label: 'Belgien', value: EnumCountry.Belgium },
    { name: 'bosnia-and-herzegovina', label: 'Bosnien und Herzegowina', value: EnumCountry.BosniaAndHerzegovina },
    { name: 'bulgaria', label: 'Bulgarien', value: EnumCountry.Bulgaria },
    { name: 'denmark', label: 'Dänemark', value: EnumCountry.Denmark },
    { name: 'estonia', label: 'Estland', value: EnumCountry.Estonia },
    { name: 'finland', label: 'Finnland', value: EnumCountry.Finland },
    { name: 'france', label: 'Frankreich', value: EnumCountry.France },
    { name: 'georgia', label: 'Georgien', value: EnumCountry.Georgia },
    { name: 'greece', label: 'Griechenland', value: EnumCountry.Greece },
    { name: 'uk', label: 'Großbritannien', value: EnumCountry.UnitedKingdom },
    { name: 'ireland', label: 'Irland', value: EnumCountry.Ireland },
    { name: 'iceland', label: 'Island', value: EnumCountry.Iceland },
    { name: 'italy', label: 'Italien', value: EnumCountry.Italy },
    { name: 'kazakhstan', label: 'Kasachstan', value: EnumCountry.Kazakhstan },
    { name: 'croatia', label: 'Kroatien', value: EnumCountry.Croatia },
    { name: 'latvia', label: 'Lettland', value: EnumCountry.Latvia },
    { name: 'liechtenstein', label: 'Liechtenstein', value: EnumCountry.Liechtenstein },
    { name: 'lithuania', label: 'Litauen', value: EnumCountry.Lithuania },
    { name: 'luxembourg', label: 'Luxemburg', value: EnumCountry.Luxembourg },
    { name: 'malta', label: 'Malta', value: EnumCountry.Malta },
    { name: 'moldova', label: 'Moldawien', value: EnumCountry.Moldova },
    { name: 'monaco', label: 'Monaco', value: EnumCountry.Monaco },
    { name: 'montenegro', label: 'Montenegro', value: EnumCountry.Montenegro },
    { name: 'netherlands', label: 'Niederlande', value: EnumCountry.Netherlands },
    { name: 'north-macedonia', label: 'Nordmazedonien', value: EnumCountry.Macedonia },
    { name: 'norway', label: 'Norwegen', value: EnumCountry.Norway },
    { name: 'poland', label: 'Polen', value: EnumCountry.Poland },
    { name: 'portugal', label: 'Portugal', value: EnumCountry.Portugal },
    { name: 'romania', label: 'Rumänien', value: EnumCountry.Romania },
    { name: 'russia', label: 'Russland', value: EnumCountry.Russia },
    { name: 'san-marino', label: 'San Marino', value: EnumCountry.SanMarino },
    { name: 'sweden', label: 'Schweden', value: EnumCountry.Sweden },
    { name: 'switzerland', label: 'Schweiz', value: EnumCountry.Switzerland },
    { name: 'serbia', label: 'Serbien', value: EnumCountry.Serbia },
    { name: 'slovakia', label: 'Slowakei', value: EnumCountry.Slovakia },
    { name: 'slovenia', label: 'Slowenien', value: EnumCountry.Slovenia },
    { name: 'spain', label: 'Spanien', value: EnumCountry.Spain },
    { name: 'czech-republic', label: 'Tschechien', value: EnumCountry.Czechia },
    { name: 'turkey', label: 'Türkei', value: EnumCountry.Turkey },
    { name: 'ukraine', label: 'Ukraine', value: EnumCountry.Ukraine },
    { name: 'hungary', label: 'Ungarn', value: EnumCountry.Hungary },
    { name: 'vatican', label: 'Vatikanstadt', value: EnumCountry.Vatican },
    { name: 'cyprus', label: 'Zypern', value: EnumCountry.Cyprus },
    { name: 'austria', label: 'Österreich', value: EnumCountry.Austria },
];
